import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UiNavSection } from '../../models/ui-sidebar.model';

@Component({
  selector: 'app-ui-sidebar-nav',
  templateUrl: './ui-sidebar-nav.component.html',
  styleUrls: ['./ui-sidebar-nav.component.scss']
})
export class UiSidebarNavComponent {
  @Input() sections: UiNavSection[] = [];
  @Input() activePath = '';
  @Input() collapsed = false;
  @Input() searchTerm = '';
  @Output() navigate = new EventEmitter<string>();

  get filteredSections(): UiNavSection[] {
    if (!this.searchTerm.trim()) {
      return this.sections;
    }
    const term = this.searchTerm.toLowerCase();
    return this.sections
      .map(section => ({
        ...section,
        items: section.items.filter(
          item => item.label.toLowerCase().includes(term) || item.path.toLowerCase().includes(term)
        )
      }))
      .filter(section => section.items.length > 0);
  }

  isActive(path: string): boolean {
    return this.activePath === path;
  }

  onNavClick(path: string): void {
    this.navigate.emit(path);
  }
}
